import { createFileRoute } from "@tanstack/react-router";
import CspLocatorPanel from "@/components/csp-locator/CspLocatorPanel";
import sentinelHelmet from "@/assets/images/sentinel-helmet.png";
import sentryNetworkLogo from "@/assets/images/Sentry_Network_Logo.png";

export const Route = createFileRoute("/(auth)/register/select-csp")({
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <div className="flex flex-col items-center md:grid md:grid-cols-[1fr_2fr] min-h-screen w-full md:h-screen md:p-0">
            <div className="w-full h-full hidden md:block overflow-hidden">
                <div className="h-full w-full flex flex-col overflow-hidden text-primary-500">
                    <div className="p-4 flex flex-col gap-4 pt-12 w-full">
                        <div className="font-bold text-lg">
                            Sentinel® Insights
                        </div>
                        <div className="text-3xl font-semibold">
                            Find a Service Provider near you
                        </div>
                        <div>
                            Our Sentry Network of Certified Service Providers
                            (CSPs) turns Sentinel's nitrogen management
                            intelligence into profitable decisions. Our CSPs are
                            agronomy experts trained to leverage Sentinel
                            solutions alongside their local expertise to
                            maximize Sentinel's value. Find your CSP to get
                            started with Sentinel today.
                        </div>
                    </div>
                    <div className="w-full h-full flex justify-center items-center">
                        <img
                            src={sentinelHelmet}
                            className="w-[20rem] h-auto object-contain"
                        />
                    </div>
                </div>
            </div>
            <div className="pt-8 px-4 w-full md:overflow-y-auto md:h-screen flex flex-col items-center">
                <img src={sentryNetworkLogo} className="px-20 md:hidden" />
                <img src={sentryNetworkLogo} className="hidden md:block w-80" />
                <div className="max-w-xl w-full mx-auto">
                    <CspLocatorPanel />
                </div>
            </div>
            <div className="md:hidden mt-12 text-primary-500 flex-1 flex flex-col">
                <div className="p-4 flex flex-col gap-4 pt-12 w-full">
                    <div className="font-bold text-lg">Sentinel® Insights</div>
                    <div className="text-3xl font-semibold">
                        Find a Service Provider near you
                    </div>
                    <div>
                        Our Sentry Network of Certified Service Providers (CSPs)
                        turns Sentinel's nitrogen management intelligence into
                        profitable decisions. Our CSPs are agronomy experts
                        trained to leverage Sentinel solutions alongside their
                        local expertise to maximize Sentinel's value. Find your
                        CSP to get started with Sentinel today.
                    </div>
                </div>
                <div className="w-full flex justify-center pb-12">
                    <img
                        src={sentinelHelmet}
                        className="w-[40%] h-auto object-contain"
                    />
                </div>
            </div>
        </div>
    );
}